module.exports = __webpack_public_path__ + "static/bg-hero-5aa32eac4f7e47cf369b5be3811226eb.png";